const adminRoot = document.querySelector("[data-admin-root]");

function initAdminContent() {
  const store = window.NMAboutContent;
  if (!store || !adminRoot || window.NMAdminContent) return;

  const contentHome = document.querySelector("[data-content-home]");
  const aboutEditor = document.querySelector('[data-content-editor="about"]');
  const homeEditor = document.querySelector('[data-content-editor="home"]');
  const portfolioEditor = document.querySelector('[data-content-editor="portfolio"]');
  const contactsEditor = document.querySelector('[data-content-editor="contacts"]');
  const servicesEditor = document.querySelector('[data-content-editor="services"]');
  const categoriesEditor = document.querySelector('[data-content-editor="categories"]');
  const categoriesItemEditor = document.querySelector('[data-content-editor="categories-item"]');
  const articlesEditor = document.querySelector('[data-content-editor="articles"]');
  const articlesItemEditor = document.querySelector('[data-content-editor="articles-item"]');
  const contentOpenButtons = document.querySelectorAll("[data-content-open]");
  const contentBackButtons = document.querySelectorAll("[data-content-back]");
  const aboutDescForm = document.querySelector("[data-about-desc-form]");
  const aboutDescNote = document.querySelector("[data-about-desc-note]");
  const achievementsForm = document.querySelector("[data-about-achievements-form]");
  const achievementsNote = document.querySelector("[data-about-achievements-note]");
  const leaderModal = document.querySelector("[data-leader-modal]");
  const leaderForm = document.querySelector("[data-leader-form]");
  const leaderFormTitle = document.querySelector("[data-leader-form-title]");
  const leaderTeamInput = document.querySelector("[data-leader-team]");
  const leaderImageInput = document.querySelector("#leader-image");
  const leaderImageData = document.querySelector("[data-leader-image-data]");
  const leaderImagePreview = document.querySelector("[data-leader-image-preview]");
  const leaderImageReset = document.querySelector("[data-leader-image-reset]");
  const historyModal = document.querySelector("[data-history-modal]");
  const historyForm = document.querySelector("[data-history-form]");
  const historyFormTitle = document.querySelector("[data-history-form-title]");
  const historyList = document.querySelector("[data-history-list]");
  const historyCount = document.querySelector("[data-history-count]");
  const historyCreateBtn = document.querySelector("[data-history-create]");

  let editingPersonId = null;
  let activeTeamKey = "leaders";
  let editingHistoryId = null;
  let noteTimer = null;

  function showNote(node) {
    if (!node) return;
    const note = node;
    note.hidden = false;
    window.clearTimeout(noteTimer);
    noteTimer = window.setTimeout(() => {
      note.hidden = true;
    }, 2200);
  }

  function clearLeaderErrors() {
    document.querySelectorAll("[data-leader-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-leader-error]");
      if (error) error.hidden = true;
    });
  }

  function clearHistoryErrors() {
    document.querySelectorAll("[data-history-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-history-error]");
      if (error) error.hidden = true;
    });
  }

  function updateImagePreview(src) {
    if (!leaderImagePreview) return;
    const img = leaderImagePreview.querySelector("img");
    if (!src) {
      leaderImagePreview.hidden = true;
      if (img) img.src = "";
      return;
    }
    if (img) img.src = src;
    leaderImagePreview.hidden = false;
  }

  function closeLeaderModal() {
    if (leaderModal) leaderModal.hidden = true;
    document.body.classList.remove("is-admin-modal-open");
    editingPersonId = null;
    activeTeamKey = "leaders";
    if (leaderForm) leaderForm.reset();
    if (leaderImageData) leaderImageData.value = "";
    if (leaderTeamInput) leaderTeamInput.value = "";
    clearLeaderErrors();
    updateImagePreview("");
  }

  function closeHistoryModal() {
    if (historyModal) historyModal.hidden = true;
    document.body.classList.remove("is-admin-modal-open");
    editingHistoryId = null;
    if (historyForm) historyForm.reset();
    clearHistoryErrors();
  }

  function openLeaderModal() {
    if (!leaderModal) return;
    leaderModal.hidden = false;
    document.body.classList.add("is-admin-modal-open");
  }

  function openHistoryModal() {
    if (!historyModal) return;
    historyModal.hidden = false;
    document.body.classList.add("is-admin-modal-open");
  }

  function fillAboutDescriptionForm() {
    if (!aboutDescForm) return;
    const { description } = store.getAboutData();
    aboutDescForm.elements.title.value = description.title || "";
    aboutDescForm.elements.paragraph1.value = description.paragraph1 || "";
    aboutDescForm.elements.paragraph2.value = description.paragraph2 || "";
    if (aboutDescNote) aboutDescNote.hidden = true;
    clearAboutDescErrors(); // eslint-disable-line no-use-before-define
    updateAboutDescFieldsUI(); // eslint-disable-line no-use-before-define
  }

  function clearAboutDescErrors() {
    aboutDescForm?.querySelectorAll("[data-about-field]").forEach((field) => {
      field.classList.remove("has-error");
      const error = field.querySelector("[data-about-error]");
      if (error) error.hidden = true;
    });
  }

  function showAboutDescError(name) {
    const field = aboutDescForm?.querySelector(`[data-about-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-about-error]");
    if (error) error.hidden = false;
  }

  function formatSymbolCount(count) {
    const mod10 = count % 10;
    const mod100 = count % 100;
    if (mod10 === 1 && mod100 !== 11) return `${count} символ`;
    if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return `${count} символа`;
    return `${count} символов`;
  }

  function autosizeAboutTextarea(textarea) {
    if (!textarea) return;
    const node = textarea;
    node.style.height = "auto";
    node.style.height = `${Math.max(node.scrollHeight, node.name === "title" ? 96 : 120)}px`;
  }

  function updateAboutDescFieldsUI() {
    if (!aboutDescForm) return;

    aboutDescForm.querySelectorAll("[data-about-input]").forEach((input) => {
      const name = input.getAttribute("data-about-input");
      const counter = aboutDescForm.querySelector(`[data-about-counter="${name}"]`);
      const value = String(input.value || "");
      if (counter) counter.textContent = formatSymbolCount(value.length);
      autosizeAboutTextarea(input);
    });
  }

  function fillAchievementsForm() {
    if (!achievementsForm) return;
    const { achievements } = store.getAboutData();
    achievements.forEach((item, index) => {
      const valueInput = achievementsForm.elements[`value${index}`];
      const labelInput = achievementsForm.elements[`label${index}`];
      if (valueInput) valueInput.value = item.value || "";
      if (labelInput) labelInput.value = item.label || "";
    });
    if (achievementsNote) achievementsNote.hidden = true;
  }

  function renderTeamList(teamKey) {
    const list = document.querySelector(`[data-team-list="${teamKey}"]`);
    const count = document.querySelector(`[data-team-count="${teamKey}"]`);
    if (!list) return;

    const people = store.getAboutData().teams[teamKey] || [];

    if (count) {
      count.textContent = people.length
        ? `Карточек: ${people.length}`
        : "Пока нет карточек — нажмите «Добавить карточку»";
    }

    if (!people.length) {
      list.innerHTML = `
        <div class="admin-panel__empty p1">
          Добавьте первого сотрудника: имя, должность и подробный текст.
        </div>
      `;
      return;
    }

    list.innerHTML = people.map((person) => `
      <article class="admin-panel__leader-card">
        <div class="admin-panel__leader-photo">
          <img src="${store.escapeHtml(person.image || store.DEFAULT_IMAGE)}" alt="${store.escapeHtml(person.name)}" width="72" height="72">
        </div>
        <div class="admin-panel__leader-body">
          <h4 class="admin-panel__leader-name h5">${store.escapeHtml(person.name)}</h4>
          <p class="admin-panel__leader-post p3">${store.escapeHtml(person.post)}</p>
          <p class="admin-panel__leader-short p3">${store.escapeHtml(person.shortDesc || "Краткое описание не указано")}</p>
        </div>
        <div class="admin-panel__leader-actions">
          <button class="admin-panel__action-btn" type="button" data-person-edit="${store.escapeHtml(person.id)}" data-team-key="${teamKey}">Изменить</button>
          <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-person-delete="${store.escapeHtml(person.id)}" data-team-key="${teamKey}">Удалить</button>
        </div>
      </article>
    `).join("");
  }

  function renderAllTeams() {
    store.TEAM_KEYS.forEach(renderTeamList);
  }

  function updateTeamTitleCounter(teamKey) {
    const input = document.querySelector(`[data-team-title-input="${teamKey}"]`);
    const counter = document.querySelector(`[data-team-title-counter="${teamKey}"]`);
    if (!input || !counter) return;
    const max = Number(input.getAttribute("maxlength")) || 80;
    counter.textContent = `${String(input.value || "").length} / ${max}`;
  }

  function clearTeamTitleError(teamKey) {
    const field = document.querySelector(`[data-team-title-field="${teamKey}"]`);
    if (!field) return;
    field.classList.remove("has-error");
    const error = document.querySelector(`[data-team-title-error="${teamKey}"]`);
    if (error) error.hidden = true;
  }

  function showTeamTitleError(teamKey) {
    const field = document.querySelector(`[data-team-title-field="${teamKey}"]`);
    if (field) field.classList.add("has-error");
    const error = document.querySelector(`[data-team-title-error="${teamKey}"]`);
    if (error) error.hidden = false;
  }

  function fillTeamTitleInputs() {
    const data = store.getAboutData();
    store.TEAM_KEYS.forEach((key) => {
      const title = store.getTeamTitle?.(key, data) || store.TEAM_TITLES[key] || "";
      const input = document.querySelector(`[data-team-title-input="${key}"]`);
      const display = document.querySelector(`[data-team-title-display="${key}"]`);
      if (input) input.value = title;
      if (display) display.textContent = title;
      clearTeamTitleError(key);
      updateTeamTitleCounter(key);
      const note = document.querySelector(`[data-team-title-note="${key}"]`);
      if (note) note.hidden = true;
    });
  }

  function saveTeamTitle(teamKey) {
    const input = document.querySelector(`[data-team-title-input="${teamKey}"]`);
    if (!input) return;
    clearTeamTitleError(teamKey);
    const value = String(input.value || "").trim();
    if (!value) {
      showTeamTitleError(teamKey);
      input.focus();
      return;
    }
    const data = store.getAboutData();
    data.teamTitles = {
      ...(data.teamTitles || {}),
      [teamKey]: value,
    };
    store.saveAboutData(data);
    fillTeamTitleInputs();
    showNote(document.querySelector(`[data-team-title-note="${teamKey}"]`));
  }

  function renderHistoryAdmin() {
    if (!historyList) return;
    const { history } = store.getAboutData();

    if (historyCount) {
      historyCount.textContent = history.length
        ? `Событий: ${history.length}`
        : "Пока нет событий — нажмите «Добавить событие»";
    }

    if (!history.length) {
      historyList.innerHTML = `
        <div class="admin-panel__empty p1">
          Добавьте первое событие: год, заголовок и текст.
        </div>
      `;
      return;
    }

    historyList.innerHTML = history.map((item) => `
      <article class="admin-panel__leader-card admin-panel__leader-card_plain">
        <div class="admin-panel__leader-body">
          <h4 class="admin-panel__leader-name h5">${store.escapeHtml(item.year)} — ${store.escapeHtml(item.title)}</h4>
          <p class="admin-panel__leader-short p3">${store.escapeHtml(item.text.slice(0, 140))}${item.text.length > 140 ? "…" : ""}</p>
        </div>
        <div class="admin-panel__leader-actions">
          <button class="admin-panel__action-btn" type="button" data-history-edit="${store.escapeHtml(item.id)}">Изменить</button>
          <button class="admin-panel__action-btn admin-panel__action-btn_danger" type="button" data-history-delete="${store.escapeHtml(item.id)}">Удалить</button>
        </div>
      </article>
    `).join("");
  }

  function showContentHome() {
    if (contentHome) contentHome.hidden = false;
    if (aboutEditor) aboutEditor.hidden = true;
    if (homeEditor) homeEditor.hidden = true;
    if (portfolioEditor) portfolioEditor.hidden = true;
    if (contactsEditor) contactsEditor.hidden = true;
    if (servicesEditor) servicesEditor.hidden = true;
    if (categoriesEditor) categoriesEditor.hidden = true;
    if (categoriesItemEditor) categoriesItemEditor.hidden = true;
    if (articlesEditor) articlesEditor.hidden = true;
    if (articlesItemEditor) articlesItemEditor.hidden = true;
    document.querySelectorAll("[data-content-editor]").forEach((editor) => {
      const node = editor;
      node.hidden = true;
    });
    closeLeaderModal();
    closeHistoryModal();
    if (window.NMAdminHomeContent?.closeHeroModal) {
      window.NMAdminHomeContent.closeHeroModal();
    }
    if (window.NMAdminPortfolioContent?.closeProjectModal) {
      window.NMAdminPortfolioContent.closeProjectModal();
    }
    if (window.NMAdminServicesContent?.closePlaqueModal) {
      window.NMAdminServicesContent.closePlaqueModal();
    }
    if (window.NMAdminCategoriesContent?.closePointModal) {
      window.NMAdminCategoriesContent.closePointModal();
    }
    if (window.NMAdminArticlesContent?.closeBlockModal) {
      window.NMAdminArticlesContent.closeBlockModal();
    }
    if (window.NMAdminFaqContent?.closeModal) {
      window.NMAdminFaqContent.closeModal();
    }
  }

  function showAboutEditor() {
    if (contentHome) contentHome.hidden = true;
    if (homeEditor) homeEditor.hidden = true;
    if (portfolioEditor) portfolioEditor.hidden = true;
    if (contactsEditor) contactsEditor.hidden = true;
    if (servicesEditor) servicesEditor.hidden = true;
    if (categoriesEditor) categoriesEditor.hidden = true;
    if (categoriesItemEditor) categoriesItemEditor.hidden = true;
    if (articlesEditor) articlesEditor.hidden = true;
    if (articlesItemEditor) articlesItemEditor.hidden = true;
    const faqEditor = document.querySelector('[data-content-editor="faq"]');
    if (faqEditor) faqEditor.hidden = true;
    if (aboutEditor) aboutEditor.hidden = false;
    fillAboutDescriptionForm();
    fillAchievementsForm();
    fillTeamTitleInputs();
    renderAllTeams();
    renderHistoryAdmin();
  }

  function showLeaderError(name) {
    const field = document.querySelector(`[data-leader-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-leader-error]");
    if (error) error.hidden = false;
  }

  function showHistoryError(name) {
    const field = document.querySelector(`[data-history-field="${name}"]`);
    if (!field) return;
    field.classList.add("has-error");
    const error = field.querySelector("[data-history-error]");
    if (error) error.hidden = false;
  }

  function fillLeaderForm(person, teamKey) {
    if (!leaderForm) return;
    leaderForm.elements.id.value = person?.id || "";
    leaderForm.elements.name.value = person?.name || "";
    leaderForm.elements.post.value = person?.post || "";
    leaderForm.elements.shortDesc.value = person?.shortDesc || "";
    leaderForm.elements.description.value = person?.description || "";
    if (leaderTeamInput) leaderTeamInput.value = teamKey || "leaders";
    if (leaderImageData) leaderImageData.value = person?.image || "";
    updateImagePreview(person?.image || "");
  }

  function openCreatePerson(teamKey) {
    editingPersonId = null;
    activeTeamKey = teamKey;
    if (leaderFormTitle) {
      const title = store.getTeamTitle?.(teamKey) || store.TEAM_TITLES[teamKey] || teamKey;
      leaderFormTitle.textContent = `Новая карточка — ${title}`;
    }
    fillLeaderForm(null, teamKey);
    clearLeaderErrors();
    openLeaderModal();
  }

  function openEditPerson(teamKey, id) {
    const person = store.getAboutData().teams[teamKey].find((item) => item.id === id);
    if (!person) return;
    editingPersonId = id;
    activeTeamKey = teamKey;
    if (leaderFormTitle) {
      const title = store.getTeamTitle?.(teamKey) || store.TEAM_TITLES[teamKey] || teamKey;
      leaderFormTitle.textContent = `Редактирование — ${title}`;
    }
    fillLeaderForm(person, teamKey);
    clearLeaderErrors();
    openLeaderModal();
  }

  function deletePerson(teamKey, id) {
    const data = store.getAboutData();
    const person = data.teams[teamKey].find((item) => item.id === id);
    if (!person) return;

    const confirmed = window.confirm(`Удалить карточку «${person.name}»?`); // eslint-disable-line no-alert
    if (!confirmed) return;

    data.teams[teamKey] = data.teams[teamKey].filter((item) => item.id !== id);
    store.saveAboutData(data);
    renderTeamList(teamKey);
  }

  function fillHistoryForm(item) {
    if (!historyForm) return;
    historyForm.elements.id.value = item?.id || "";
    historyForm.elements.year.value = item?.year || "";
    historyForm.elements.title.value = item?.title || "";
    historyForm.elements.text.value = item?.text || "";
    historyForm.elements.linkText.value = item?.linkText || "Проект";
    historyForm.elements.link.value = item?.link && item.link !== "#" ? item.link : "";
  }

  function openCreateHistory() {
    editingHistoryId = null;
    if (historyFormTitle) historyFormTitle.textContent = "Новое событие";
    fillHistoryForm(null);
    clearHistoryErrors();
    openHistoryModal();
  }

  function openEditHistory(id) {
    const item = store.getAboutData().history.find((entry) => entry.id === id);
    if (!item) return;
    editingHistoryId = id;
    if (historyFormTitle) historyFormTitle.textContent = "Редактирование события";
    fillHistoryForm(item);
    clearHistoryErrors();
    openHistoryModal();
  }

  function deleteHistory(id) {
    const data = store.getAboutData();
    const item = data.history.find((entry) => entry.id === id);
    if (!item) return;

    const confirmed = window.confirm(`Удалить событие «${item.year} — ${item.title}»?`); // eslint-disable-line no-alert
    if (!confirmed) return;

    data.history = data.history.filter((entry) => entry.id !== id);
    store.saveAboutData(data);
    renderHistoryAdmin();
  }

  function handleAboutDescSubmit(event) {
    event.preventDefault();
    clearAboutDescErrors();

    const data = store.getAboutData();
    data.description = {
      title: String(aboutDescForm.elements.title.value || "").trim(),
      paragraph1: String(aboutDescForm.elements.paragraph1.value || "").trim(),
      paragraph2: String(aboutDescForm.elements.paragraph2.value || "").trim(),
    };

    let hasError = false;
    if (!data.description.title) {
      showAboutDescError("title");
      hasError = true;
    }
    if (!data.description.paragraph1) {
      showAboutDescError("paragraph1");
      hasError = true;
    }
    if (!data.description.paragraph2) {
      showAboutDescError("paragraph2");
      hasError = true;
    }
    if (hasError) return;

    store.saveAboutData(data);
    showNote(aboutDescNote);
  }

  function handleAchievementsSubmit(event) {
    event.preventDefault();
    const data = store.getAboutData();
    data.achievements = [0, 1, 2].map((index) => ({
      value: String(achievementsForm.elements[`value${index}`].value || "").trim(),
      label: String(achievementsForm.elements[`label${index}`].value || "").trim(),
    }));

    if (data.achievements.some((item) => !item.value || !item.label)) {
      return;
    }

    store.saveAboutData(data);
    showNote(achievementsNote);
  }

  function handleLeaderSubmit(event) {
    event.preventDefault();
    clearLeaderErrors();

    const formData = new FormData(leaderForm);
    const teamKey = String(formData.get("team") || activeTeamKey || "leaders");
    const payload = store.normalizePerson({
      id: editingPersonId || store.createId(),
      name: formData.get("name"),
      post: formData.get("post"),
      shortDesc: formData.get("shortDesc"),
      description: formData.get("description"),
      image: leaderImageData?.value || store.DEFAULT_IMAGE,
    });

    let hasError = false;
    if (!payload.name) {
      showLeaderError("name");
      hasError = true;
    }
    if (!payload.post) {
      showLeaderError("post");
      hasError = true;
    }
    if (!payload.description) {
      showLeaderError("description");
      hasError = true;
    }
    if (hasError) return;

    const data = store.getAboutData();
    if (!data.teams[teamKey]) data.teams[teamKey] = [];
    const index = data.teams[teamKey].findIndex((item) => item.id === payload.id);
    if (index >= 0) {
      data.teams[teamKey][index] = payload;
    } else {
      data.teams[teamKey].push(payload);
    }

    store.saveAboutData(data);
    closeLeaderModal();
    renderTeamList(teamKey);
  }

  function handleHistorySubmit(event) {
    event.preventDefault();
    clearHistoryErrors();

    const formData = new FormData(historyForm);
    const payload = store.normalizeHistoryItem({
      id: editingHistoryId || store.createId(),
      year: formData.get("year"),
      title: formData.get("title"),
      text: formData.get("text"),
      linkText: formData.get("linkText") || "Проект",
      link: formData.get("link") || "#",
    });

    let hasError = false;
    if (!payload.year) {
      showHistoryError("year");
      hasError = true;
    }
    if (!payload.title) {
      showHistoryError("title");
      hasError = true;
    }
    if (!payload.text) {
      showHistoryError("text");
      hasError = true;
    }
    if (hasError) return;

    const data = store.getAboutData();
    const index = data.history.findIndex((item) => item.id === payload.id);
    if (index >= 0) {
      data.history[index] = payload;
    } else {
      data.history.push(payload);
    }

    store.saveAboutData(data);
    closeHistoryModal();
    renderHistoryAdmin();
  }

  contentOpenButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const page = button.getAttribute("data-content-open");
      if (page === "about") showAboutEditor();
    });
  });

  contentBackButtons.forEach((button) => {
    button.addEventListener("click", showContentHome);
  });

  document.querySelectorAll('[data-admin-link="content"]').forEach((link) => {
    link.addEventListener("click", () => {
      window.setTimeout(showContentHome, 0);
    });
  });

  if (aboutDescForm) {
    aboutDescForm.addEventListener("submit", handleAboutDescSubmit);
    aboutDescForm.querySelectorAll("[data-about-input]").forEach((input) => {
      input.addEventListener("input", () => {
        const field = input.closest("[data-about-field]");
        if (field) {
          field.classList.remove("has-error");
          const error = field.querySelector("[data-about-error]");
          if (error) error.hidden = true;
        }
        updateAboutDescFieldsUI();
      });
    });
  }

  if (achievementsForm) {
    achievementsForm.addEventListener("submit", handleAchievementsSubmit);
  }

  document.querySelectorAll("[data-person-create]").forEach((button) => {
    button.addEventListener("click", () => {
      openCreatePerson(button.getAttribute("data-person-create") || "leaders");
    });
  });

  document.querySelectorAll("[data-team-title-save]").forEach((button) => {
    button.addEventListener("click", () => {
      saveTeamTitle(button.getAttribute("data-team-title-save") || "");
    });
  });

  document.querySelectorAll("[data-team-title-input]").forEach((input) => {
    const teamKey = input.getAttribute("data-team-title-input") || "";
    input.addEventListener("input", () => {
      clearTeamTitleError(teamKey);
      updateTeamTitleCounter(teamKey);
      const display = document.querySelector(`[data-team-title-display="${teamKey}"]`);
      if (display) {
        display.textContent = String(input.value || "").trim()
          || store.TEAM_TITLES[teamKey]
          || "Без названия";
      }
    });
    input.addEventListener("keydown", (event) => {
      if (event.key !== "Enter") return;
      event.preventDefault();
      saveTeamTitle(teamKey);
    });
  });

  if (leaderForm) {
    leaderForm.addEventListener("submit", handleLeaderSubmit);
  }

  document.querySelectorAll("[data-leader-modal-close]").forEach((element) => {
    element.addEventListener("click", closeLeaderModal);
  });

  store.TEAM_KEYS.forEach((teamKey) => {
    const list = document.querySelector(`[data-team-list="${teamKey}"]`);
    if (!list) return;
    list.addEventListener("click", (event) => {
      const editBtn = event.target.closest("[data-person-edit]");
      const deleteBtn = event.target.closest("[data-person-delete]");

      if (editBtn) {
        openEditPerson(
          editBtn.getAttribute("data-team-key") || teamKey,
          editBtn.getAttribute("data-person-edit"),
        );
      }

      if (deleteBtn) {
        deletePerson(
          deleteBtn.getAttribute("data-team-key") || teamKey,
          deleteBtn.getAttribute("data-person-delete"),
        );
      }
    });
  });

  if (leaderImageInput) {
    leaderImageInput.addEventListener("change", () => {
      const file = leaderImageInput.files && leaderImageInput.files[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = () => {
        const result = String(reader.result || "");
        if (leaderImageData) leaderImageData.value = result;
        updateImagePreview(result);
      };
      reader.readAsDataURL(file);
    });
  }

  if (leaderImageReset) {
    leaderImageReset.addEventListener("click", () => {
      if (leaderImageInput) leaderImageInput.value = "";
      if (leaderImageData) leaderImageData.value = store.DEFAULT_IMAGE;
      updateImagePreview(store.DEFAULT_IMAGE);
    });
  }

  if (historyCreateBtn) {
    historyCreateBtn.addEventListener("click", openCreateHistory);
  }

  if (historyForm) {
    historyForm.addEventListener("submit", handleHistorySubmit);
  }

  document.querySelectorAll("[data-history-modal-close]").forEach((element) => {
    element.addEventListener("click", closeHistoryModal);
  });

  if (historyList) {
    historyList.addEventListener("click", (event) => {
      const editBtn = event.target.closest("[data-history-edit]");
      const deleteBtn = event.target.closest("[data-history-delete]");

      if (editBtn) openEditHistory(editBtn.getAttribute("data-history-edit"));
      if (deleteBtn) deleteHistory(deleteBtn.getAttribute("data-history-delete"));
    });
  }

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    if (leaderModal && !leaderModal.hidden) closeLeaderModal();
    if (historyModal && !historyModal.hidden) closeHistoryModal();
    if (window.NMAdminArticlesContent?.closeBlockModal) {
      window.NMAdminArticlesContent.closeBlockModal();
    }
  });

  window.NMAdminContent = {
    showContentHome,
    showAboutEditor,
    renderAllTeams,
    renderHistoryAdmin,
  };
}

if (adminRoot) {
  initAdminContent();
  window.setTimeout(initAdminContent, 0);
}
